import Handsontable from "handsontable";
import { TextEditor } from "handsontable/editors/textEditor";

export class DateTimeEditor extends TextEditor {
  createElements() {
    super.createElements();

    this.TEXTAREA = document.createElement("input");
    this.TEXTAREA.setAttribute("type", "datetime-local");
    this.TEXTAREA.className = "handsontableInput";
    this.textareaStyle = this.TEXTAREA.style;
    this.textareaStyle.width = 0;
    this.textareaStyle.height = 0;

    Handsontable.dom.empty(this.TEXTAREA_PARENT);
    this.TEXTAREA_PARENT.appendChild(this.TEXTAREA);
  }

  prepare(row, col, prop, td, originalValue, cellProperties) {
    super.prepare(row, col, prop, td, originalValue, cellProperties);

    // Convert date string to datetime-local format (YYYY-MM-DDTHH:mm)
    if (originalValue) {
      const date = new Date(originalValue);
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        this.TEXTAREA.value = `${year}-${month}-${day}T${hours}:${minutes}`;
      }
    }
  }

  focus() {
    this.TEXTAREA.select();
  }

  beginEditing(initialValue, event) {
    super.beginEditing(initialValue, event);

    if (this.originalValue) {
      const date = new Date(this.originalValue);
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        this.TEXTAREA.value = `${year}-${month}-${day}T${hours}:${minutes}`;
      }
    }
  }

  getValue() {
    // if (this.TEXTAREA.value) {
    //   console.log(this.TEXTAREA.value);
    //   return new Date(this.TEXTAREA.value).toISOString();
    // }
    // return this.TEXTAREA.value;

    return this.TEXTAREA.value;
  }
}
